import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type ModalsContextValue = {
  isModalOpen: Record<string, boolean>;
  openModal: (modalId: string) => void;
  closeModal: (modalId: string) => void;
};

const ModalsContext = createContext<ModalsContextValue>({
  isModalOpen: {},
  openModal: () => undefined,
  closeModal: () => undefined,
});

// App-wide open/closed registry for the trial/upgrade modals, keyed by the
// ids in consts/modals. Replaces the old redux ui.modals slice.
export function ModalsProvider ({ children }: { children: React.ReactNode }) {
  const [isModalOpen, setIsModalOpen] = useState<Record<string, boolean>>({});
  const openModal = useCallback(
    (modalId: string) => setIsModalOpen((s) => ({ ...s, [modalId]: true })),
    []
  );
  const closeModal = useCallback(
    (modalId: string) => setIsModalOpen((s) => ({ ...s, [modalId]: false })),
    []
  );
  const value = useMemo(
    () => ({ isModalOpen, openModal, closeModal }),
    [isModalOpen, openModal, closeModal]
  );
  return <ModalsContext.Provider value={value}>{children}</ModalsContext.Provider>;
}

export function useModals () {
  return useContext(ModalsContext);
}
